import { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import { ReactComponent as IconChevronSm } from 'assets/icons/IconChevronSm.svg'
import { ReactComponent as IconChevronOpen } from 'assets/icons/IconChevronOpen.svg'

const SectionAccordion = ({ title = '', children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const onClickChevronButton = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className="section-accordion">
      <header
        className={cn('section-accordion__header', { '-closed': !isOpen })}
      >
        <h4 className="section-accordion__main-header">{title}</h4>
        <button
          className="section-accordion__open-button"
          onClick={onClickChevronButton}
        >
          {isOpen ? <IconChevronOpen /> : <IconChevronSm />}
        </button>
      </header>
      <div className={cn('section-accordion__content', { '-open': isOpen })}>
        {children}
      </div>
    </div>
  )
}

SectionAccordion.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
}

export default SectionAccordion
